import React from 'react';
import style from './style.module.scss';
import {Tooltip} from 'components/Tooltip';
import {Typography} from 'components/Typography';
import cs from 'classnames';

interface IOnlineOnlyLabelProps {
    className?: string;
}

export const OnlineDiscountBadge = (props: IOnlineOnlyLabelProps) => {
    const {className} = props;

    return (
        <Tooltip
            childrenClassName={style.tooltip}
            overlay={
                <div className={style.tooltip__content}>
                    <Typography variant={'label-12-r'}>Скидка действует только на сайте и в приложении</Typography>
                </div>
            }
        >
            <div className={cs(style.label, className)}>
                <Typography className={style.label__text} element={'div'} variant={'p-small'}>
                    Скидка онлайн
                </Typography>
            </div>
        </Tooltip>
    );
};
